<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="565px" :before-close="closeModal">
    <AlertExclamationRegister size="40" color="#FFAC00" class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2">
        Tem certeza que deseja sair sem concluir<br>o cadastro da empresa?
    </h3>
    <p class="c-ndarkfour text-center">
        Se você sair agora, <span class="bold">seus dados preenchidos não serão salvos.</span>
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <!-- <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Cancelar
        </router-link> -->
        <router-link to="" @click.native="saveChanges"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Salvar e sair
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="cancelRegister">
            Sair mesmo assim
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
export default {
    components: {
      AlertExclamationRegister
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        cancelRegister() {
            this.$emit('cancelRegister')
        },
        saveChanges() {
            this.$emit('saveChange')
            this.$emit('cancelRegister')
        }
    },
}
</script>

<style scoped>
.btn-link {
    padding: 10px 32px;
    border-radius: 20px;
}
</style>